export default "__VITE_ASSET__DX8rI7$s__"